"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var AxiosErrorParser_1 = require("Errors/AxiosErrorParser");
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var SecurityController = (function () {
    function SecurityController(createUi, rootDataStore, mountReactComponent, modal) {
        this.ui = createUi(require("./Security.html"), {
            securitySettings: mountReactComponent(react_1.default.createElement(SecuritySettings, { accountStore: rootDataStore.getAccountDataStore(), modal: modal })),
        });
    }
    return SecurityController;
}());
var EditStatus;
(function (EditStatus) {
    EditStatus[EditStatus["Unsaved"] = 0] = "Unsaved";
    EditStatus[EditStatus["Saving"] = 1] = "Saving";
    EditStatus[EditStatus["Saved"] = 2] = "Saved";
    EditStatus[EditStatus["Error"] = 3] = "Error";
})(EditStatus || (EditStatus = {}));
var SecuritySettings = (function (_super) {
    __extends(SecuritySettings, _super);
    function SecuritySettings(props) {
        var _this = _super.call(this, props) || this;
        _this.editStatus = EditStatus.Saved;
        _this.errorMessage = "";
        _this.save = function () { return __awaiter(_this, void 0, Promise, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.setEditStatus(EditStatus.Saving);
                        return [4, this.props.accountStore.setAuthenticationSettings(this.settings)];
                    case 1:
                        _a.sent();
                        this.setEditStatus(EditStatus.Saved);
                        return [3, 3];
                    case 2:
                        err_1 = _a.sent();
                        this.setErrorMessage((0, AxiosErrorParser_1.isAxiosError)(err_1) ? (0, AxiosErrorParser_1.getErrorMessage)(err_1) : "Something went wrong. Please try again in a moment");
                        this.setEditStatus(EditStatus.Error);
                        throw err_1;
                    case 3: return [2];
                }
            });
        }); };
        _this.settings = (0, mobx_1.toJS)(props.accountStore.authenticationSettings);
        return _this;
    }
    SecuritySettings.prototype.toggleSetting = function (key, toggleMap) {
        if (toggleMap[this.settings[key]]) {
            if (key === "hubspot" &&
                this.settings[key] === Types_1.AuthenticationStatus.Enabled &&
                this.props.accountStore.integrations.hubspot.enabled) {
                this.props.modal.showAcknowledgeModal({
                    title: "HubSpot SSO is required",
                    explainer: "The HubSpot integration requires the HubSpot SSO login method. Since your account has the HubSpot integration enabled, the HubSpot SSO login method is also required. If you want to disable this SSO method you\u2019ll need to disable the HubSpot integration.",
                    buttonLabel: "Got it",
                });
            }
            else {
                this.settings[key] = toggleMap[this.settings[key]];
            }
        }
        else {
            throw new Error("Unhandled authentication status");
        }
        this.editStatus = EditStatus.Unsaved;
    };
    SecuritySettings.prototype.setErrorMessage = function (error) {
        this.errorMessage = error;
    };
    SecuritySettings.prototype.setEditStatus = function (status) {
        this.editStatus = status;
    };
    SecuritySettings.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: "security-settings" },
            react_1.default.createElement("header", { className: "setting-section-header" },
                react_1.default.createElement("h2", null, "Security"),
                react_1.default.createElement("p", { className: "explainer" }, "Control how users are able to sign into this account.")),
            react_1.default.createElement("div", { className: "security-settings__body" },
                react_1.default.createElement("div", { className: "security-settings__auth-section" }, [
                    Types_1.AUTHENTICATION_CONFIG.google,
                    Types_1.AUTHENTICATION_CONFIG.salesforce,
                    Types_1.AUTHENTICATION_CONFIG.hubspot,
                    Types_1.AUTHENTICATION_CONFIG.microsoft,
                    Types_1.AUTHENTICATION_CONFIG.email,
                ].map(function (_a) {
                    var displayName = _a.displayName, internalName = _a.internalName;
                    return (react_1.default.createElement(kaleidoscope_1.Checkbox, { key: internalName, item: { id: internalName, value: internalName, label: displayName }, isSelected: _this.settings[internalName] === Types_1.AuthenticationStatus.Enabled, toggleKey: internalName, onChange: function () {
                            var _a;
                            return _this.toggleSetting(internalName, (_a = {},
                                _a[Types_1.AuthenticationStatus.Enabled] = Types_1.AuthenticationStatus.Disabled,
                                _a[Types_1.AuthenticationStatus.Disabled] = Types_1.AuthenticationStatus.Enabled,
                                _a[Types_1.AuthenticationStatus.AdminOnly] = Types_1.AuthenticationStatus.Enabled,
                                _a));
                        } }));
                })),
                react_1.default.createElement("div", { className: "security-settings__auth-admin-section" },
                    react_1.default.createElement("h5", { className: "security-settings__sub-heading" }, "Allow email login for Admins"),
                    react_1.default.createElement("p", { className: "security-settings__text" }, "Enable account admins to login with their email and password, in addition to SSO (Single Sign On). This may be useful as a backup method, if your SSO provider is unavailable."),
                    react_1.default.createElement(kaleidoscope_1.Checkbox, { key: Types_1.AUTHENTICATION_CONFIG.email.internalName, item: {
                            id: Types_1.AUTHENTICATION_CONFIG.email.internalName,
                            value: Types_1.AUTHENTICATION_CONFIG.email.internalName,
                            label: "".concat(Types_1.AUTHENTICATION_CONFIG.email.displayName, " (admin only)"),
                        }, isSelected: this.settings[Types_1.AUTHENTICATION_CONFIG.email.internalName] === Types_1.AuthenticationStatus.AdminOnly, toggleKey: Types_1.AUTHENTICATION_CONFIG.email.internalName, onChange: function () {
                            var _a;
                            return _this.toggleSetting(Types_1.AUTHENTICATION_CONFIG.email.internalName, (_a = {},
                                _a[Types_1.AuthenticationStatus.Disabled] = Types_1.AuthenticationStatus.AdminOnly,
                                _a[Types_1.AuthenticationStatus.Enabled] = Types_1.AuthenticationStatus.AdminOnly,
                                _a[Types_1.AuthenticationStatus.AdminOnly] = Types_1.AuthenticationStatus.Disabled,
                                _a));
                        } }))),
            react_1.default.createElement(kaleidoscope_1.ErrorTooltip, { renderTooltip: this.editStatus === EditStatus.Error, content: this.errorMessage, position: kaleidoscope_1.TooltipPosition.Top, size: kaleidoscope_1.TooltipSize.Large },
                react_1.default.createElement(kaleidoscope_1.Button, { className: "security-settings__save", onClick: this.save, disabled: this.editStatus !== EditStatus.Unsaved }, "Save"))));
    };
    var _a;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_a = typeof Types_1.AuthenticationSettings !== "undefined" && Types_1.AuthenticationSettings) === "function" ? _a : Object)
    ], SecuritySettings.prototype, "settings", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SecuritySettings.prototype, "editStatus", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SecuritySettings.prototype, "errorMessage", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", void 0)
    ], SecuritySettings.prototype, "toggleSetting", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SecuritySettings.prototype, "setErrorMessage", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], SecuritySettings.prototype, "setEditStatus", null);
    SecuritySettings = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], SecuritySettings);
    return SecuritySettings;
}(react_1.default.Component));
exports.default = SecurityController;
